import React from 'react';
import { ActionCableConsumer } from '@thrash-industries/react-actioncable-provider';

const DataActionCable = ({ setStartCsvQuery, ticketId }) => {

    return (
        <ActionCableConsumer
            channel={{
                channel: "ExportDataChannel",
                id: `${ticketId}`
            }}
            onReceived={(message) => {
                setStartCsvQuery(message)
            }}
        ></ActionCableConsumer>
    );
};

export default DataActionCable;

